import { BaseApiService } from '@/shared/api/services/base.service';
import type { Palette, PalettesResponse } from '@/types/palette';

class PalettesService extends BaseApiService {
  async getPalettes(): Promise<Palette[]> {
    const response = await this.httpGet<PalettesResponse>('/v1/palettes');
    return response.data;
  }
}

export const palettesService = new PalettesService();
